import { FC } from 'react'
import { MiFooter } from '../../components/mi/Footer'
import { MiNavbar } from '../../components/mi/Navbar'
import { ShowMiSection } from '../../components/mi/account/showMi'
import { StyleBody } from '../../styles/mi'

export const ShowMi: FC = () => {
  return (
    <StyleBody>
      <MiNavbar />
      <ShowMiSection></ShowMiSection>
      <MiFooter />
    </StyleBody>
  )
}
